import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import t from "styled-components";
var o = t.div.withConfig({
  displayName: "ModalContainer",
  componentId: "VDS__sc-v5rd4m-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: ", ";\n"])), function (_ref) {
  var t = _ref.$zIndex;
  return t;
});
export { o as default };